import { useAppSelector } from "hooks/hooksStore"
import { useEffect, useState } from "react"
import { RootState } from "store/store"
import { checkAccess } from "utils/helpers"

interface Props {
  children: JSX.Element
  moduleId: number | number[]
  subModule: string
  feature: string
  exception?: boolean
}

function PermissionWrapper({ children, moduleId, subModule, feature, exception }: Props) {
  const { authUser } = useAppSelector((state: RootState) => state.common)

  const [permission, setPermission] = useState<boolean>(false)

  useEffect(() => {
    if (!authUser) return
    const moduleIds = typeof moduleId === "number" ? [moduleId] : moduleId
    const featureAccess = checkAccess(authUser?.roles, moduleIds, subModule, feature)
    setPermission(featureAccess)
  }, [authUser])

  return permission || exception ? children : null
}

export default PermissionWrapper
